import React from 'react';
import { Crown, Mail, MessageSquare, Send } from 'lucide-react';
import { useMediaQuery, Box, Typography, Divider } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { CustomPaletteColor } from '../../theme';
import { FlexBetween } from '../FlexBetween';
import { SiteLogoProps } from './SiteLogo.types'; // Assuming you have a separate file for types
import { getSiteLogoAccentIconColor, getSiteLogoAccentTextColor } from './siteLogoTheme';


export const MinifiedCKSiteLogo: React.FC<SiteLogoProps> = ({ varient }: SiteLogoProps) => {
    let isNonMobile = useMediaQuery('(min-width: 600px)');
    isNonMobile = varient === 'small' ? false : isNonMobile; // Override for small variant
    const theme = useTheme();
    const accentIconColor = getSiteLogoAccentIconColor(theme);
    const accentTextColor = getSiteLogoAccentTextColor(theme, (theme.palette.primary as CustomPaletteColor)[200]);
    return (
        <Box
            sx={{
                padding: varient === 'small' ? '0.9rem' : '0rem',
            }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: !isNonMobile ? 'center' : 'flex-start',
                    width: '100%',
                }}>

                {/* Logo Container */}
                <FlexBetween sx={{
                    gap: isNonMobile ? "9.2rem" : '1rem',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    {/* Crown Icon */}
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'left',
                        marginLeft: '0rem',
                        animation: 'bounce 1s infinite',
                        '@keyframes bounce': {
                            '0%, 100%': { transform: 'translateY(0)' },
                            '50%': { transform: 'translateY(-10px)' },
                        },
                        transition: 'transform 0.3s ease',
                        position: 'relative',
                    }}>
                        <Crown strokeWidth={1.5} width={isNonMobile ? 50: 40} height={isNonMobile ? 50:40} color={accentIconColor} style={{ transform: 'rotate(0deg' }} />
                    </Box>
                </FlexBetween>
                <Box sx={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontFamily: 'Poppins, sans-serif' }}>
                    <Typography variant='h1' align='center' sx={{color: (theme.palette.secondary as CustomPaletteColor)[200], fontSize: isNonMobile ? '2.5rem' : '1.5rem', fontWeight: 'bold', textAlign: 'center' }}>
                        C<span style={{ color: accentTextColor }}>K</span>
                    </Typography>
                </Box>

            </Box>
        </Box>
    );
};
